import { Shader3D } from "./Shader3D";
export class ShaderVariant {
    get shader() {
        return this._shader;
    }
    get subShaderIndex() {
        return this._subShaderIndex;
    }
    get passIndex() {
        return this._passIndex;
    }
    get defineNames() {
        return this._defineNames;
    }
    constructor(shader, subShaderIndex, passIndex, defines) {
        this._subShaderIndex = 0;
        this._passIndex = 0;
        this.setValue(shader, subShaderIndex, passIndex, defines);
    }
    setValue(shader, subShaderIndex, passIndex, defineNames) {
        if (shader) {
            var subShader = shader.getSubShaderAt(subShaderIndex);
            if (subShader) {
                var pass = subShader._passes[passIndex];
                if (pass) {
                    var validDefine = pass._validDefine;
                    for (var i = 0, n = defineNames.length; i < n; i++) {
                        var defname = defineNames[i];
                        if (!validDefine.has(Shader3D.getDefineByName(defname)))
                            throw `ShaderVariantInfo:Invalid defineName ${defname} in ${shader._name} subShaderIndex of ${subShaderIndex} passIndex of ${passIndex}.`;
                    }
                }
                else {
                    throw `ShaderVariantInfo:Shader don't have passIndex of ${passIndex}.`;
                }
            }
            else {
                throw `ShaderVariantInfo:Shader don't have subShaderIndex of ${subShaderIndex}.`;
            }
        }
        else {
            throw `ShaderVariantInfo:Shader can't be null.`;
        }
        this._shader = shader;
        this._subShaderIndex = subShaderIndex;
        this._passIndex = passIndex;
        this._defineNames = defineNames;
    }
    equal(other) {
        if (this._shader !== other._shader || this._subShaderIndex !== other._subShaderIndex || this._passIndex !== other._passIndex)
            return false;
        var defines = this._defineNames;
        var otherDefines = other._defineNames;
        if (defines.length !== otherDefines.length)
            return false;
        for (var i = 0, n = this._defineNames.length; i < n; i++) {
            if (defines[i] !== otherDefines[i])
                return false;
        }
        return true;
    }
    clone() {
        var dest = new ShaderVariant(this._shader, this._subShaderIndex, this._passIndex, this._defineNames.slice());
        return dest;
    }
}
export class ShaderVariantCollection {
    constructor(items) {
        this.items = items || {};
    }
    add(shaderPass, defines) {
        var _a;
        let shader = shaderPass._owner._owner;
        let subShaderIndex = shader._subShaders.indexOf(shaderPass._owner);
        let passIndex = shaderPass._owner._passes.indexOf(shaderPass);
        let nodeCommonMap = shaderPass.nodeCommonMap;
        let additionMap = (_a = shaderPass.additionShaderData) !== null && _a !== void 0 ? _a : [];
        if (!nodeCommonMap)
            return;
        defines = defines.filter((v) => !Shader3D._configDefineValues.has(Shader3D.getDefineByName(v)));
        let col = this.items[shader._name];
        if (!col) {
            col = [];
            this.items[shader._name] = col;
        }
        if (col.some(v => {
            return (v.subShaderIndex === subShaderIndex &&
                v.passIndex === passIndex &&
                v.defines.length === defines.length &&
                v.defines.every((name, index) => name === defines[index]) &&
                v.nodeCommonMap.length === nodeCommonMap.length &&
                v.nodeCommonMap.every((name, index) => name === nodeCommonMap[index]) &&
                v.additionMap.length === additionMap.length &&
                v.additionMap.every((name, index) => name === additionMap[index]));
        }))
            return;
        col.push({
            subShaderIndex: subShaderIndex,
            passIndex: passIndex,
            defines: defines,
            nodeCommonMap: nodeCommonMap.concat(),
            additionMap: additionMap.concat()
        });
        console.debug(`Shader variant: ${shader._name}/${subShaderIndex}/${passIndex}/${defines.join(",")}/${nodeCommonMap ? nodeCommonMap.join(",") : ""}/${additionMap ? additionMap.join(",") : ""}`);
    }
    compileAll() {
        let items = this.items;
        for (let shaderName in items) {
            let variants = items[shaderName];
            for (let variant of variants) {
                let suc = Shader3D.compileShaderByDefineNames(shaderName, variant.subShaderIndex, variant.passIndex, variant.defines, variant.nodeCommonMap, variant.additionMap);
                let msg = `${shaderName}/${variant.subShaderIndex}/${variant.passIndex}/${variant.defines.join(",")}/${variant.nodeCommonMap ? variant.nodeCommonMap.join(",") : ""}/${variant.additionMap ? variant.additionMap.join(",") : ""}`;
                if (suc)
                    console.debug("Warm up", msg);
                else
                    console.warn("Warm up failed!", msg);
            }
        }
    }
}
ShaderVariantCollection.active = new ShaderVariantCollection();
